import type { IFollowUpReflectionDocumentForm } from 'types/kinerja-pelaksanaan'

export const FOLLOW_UP_REFLECTION_CONTENT: Record<
  keyof IFollowUpReflectionDocumentForm,
  { question: string; label: string }
> = {
  inspiration: {
    question: 'Apa inspirasi baru yang Anda dapatkan dari upaya tindak lanjut?',
    label: 'Inspirasi',
  },
  achievement: {
    question:
      'Berdasarkan inspirasi yang Anda dapatkan, apa perubahan praktik Anda di ruang kelas/satuan pendidikan yang telah Anda lakukan?',
    label: 'Capaian',
  },
  challenge: {
    question:
      'Apa 3 tantangan paling sulit yang akan Anda hadapi dalam melakukan perubahan tersebut?',
    label: 'Tantangan',
  },
  improvementPlan: {
    question:
      'Bagaimana rencana Anda dalam mengatasi tantangan tersebut agar bisa memastikan perubahan terjadi?',
    label: 'Upaya Perbaikan',
  },
  additionalInspiration: {
    question: 'Apa inspirasi baru yang Anda dapatkan dari upaya tindak lanjut?',
    label: 'Inspirasi',
  },
  additionalAchievement: {
    question:
      'Berdasarkan inspirasi yang Anda dapatkan, apa perubahan praktik Anda di ruang kelas/satuan pendidikan yang telah Anda lakukan?',
    label: 'Capaian',
  },
  additionalChallenge: {
    question:
      'Apa 3 tantangan paling sulit yang akan Anda hadapi dalam melakukan perubahan tersebut?',
    label: 'Tantangan',
  },
  additionalImprovementPlan: {
    question:
      'Bagaimana rencana Anda dalam mengatasi tantangan tersebut agar bisa memastikan perubahan terjadi?',
    label: 'Upaya Perbaikan',
  },
}

export const FOLLOW_UP_REFLECTION_CONTENT_KS: Record<
  keyof Pick<
    IFollowUpReflectionDocumentForm,
    'inspiration' | 'achievement' | 'challenge' | 'improvementPlan'
  >,
  { question: string; label: string }
> = {
  inspiration: {
    question: 'Inspirasi baru yang guru dapatkan dari upaya tindak lanjut:',
    label: 'Inspirasi',
  },
  achievement: {
    question:
      'Berdasarkan inspirasi yang didapatkan, perubahan praktik guru di ruang kelas/satuan pendidikan:',
    label: 'Capaian',
  },
  challenge: {
    question:
      '3 tantangan paling sulit yang guru hadapi dalam melakukan perubahan:',
    label: 'Tantangan',
  },
  improvementPlan: {
    question:
      'Rencana guru dalam mengatasi tantangan agar bisa memastikan perubahan terjadi:',
    label: 'Upaya Perbaikan',
  },
}
